<form [formGroup]="form">
  <p-datepicker
  appendTo="body"
  [locale]="se"
  [showButtonBar]="true"
  [monthNavigator]="true"
  [showWeek]="true"
  [inputStyle]="{'width':'160px'}"
  [yearNavigator]="true"
  showTime="{{showTime}}"
  yearRange="1720:2030"
  dateFormat="yy-mm-dd"
  formControlName="{{formName}}"
  [readonlyInput]="false"
  required="{{required}}"
  (onSelect)="changedDate($event)">
  </p-datepicker>
  </form>
